import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, useBreakpointValue } from '@chakra-ui/react';
import { Background } from './Background.styles';

const BackgroundWrapper = ({ children, applyMd }) => {
  const Wrapper = useBreakpointValue({
    base: WrapperMobile,
    md: applyMd ? WrapperDesktop : WrapperMobile,
    lg: WrapperDesktop,
  });

  return <Wrapper>{children}</Wrapper>;
};

BackgroundWrapper.propTypes = {
  children: PropTypes.node,
  applyMd: PropTypes.bool,
};

const WrapperDesktop = ({ children }) => {
  return (
    <Background>
      <Flex
        height="100vh"
        alignItems="center" // Centers vertically
      >
        {children}
      </Flex>
    </Background>
  );
};
WrapperDesktop.propTypes = {
  children: PropTypes.node,
};

const WrapperMobile = ({ children }) => <Box mt={20}>{children}</Box>;
WrapperMobile.propTypes = {
  children: PropTypes.node,
};

export default BackgroundWrapper;
